import { Stack } from 'expo-router';
import { colors } from '../../../src/theme/colors';

export default function OnboardingLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
        animation: 'slide_from_right',
      }}
    >
      <Stack.Screen name="name" />
      <Stack.Screen name="birth-date" />
      <Stack.Screen name="birth-time" />
      <Stack.Screen name="birth-place" />
      <Stack.Screen name="chart-reveal" />
      <Stack.Screen name="personality" />
      <Stack.Screen name="methodology" />
      <Stack.Screen name="purpose" />
      <Stack.Screen name="interests" />
    </Stack>
  );
}
